import React, { useState, useEffect } from 'react';

const icons = {
  mapPin: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
    </svg>
  ),
  phone: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
    </svg>
  ),
  mail: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>
    </svg>
  ),
  clock: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
    </svg>
  ),
  check: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>
    </svg>
  ),
  send: (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/>
    </svg>
  ),
};

function Contact() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    service: '',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);
  const [submitError, setSubmitError] = useState(false);

  useEffect(() => {
    document.title = 'Contact Royal Parcel | North Hollywood, CA — (818) 299-3899';
    document.querySelector('meta[name="description"]')?.setAttribute('content',
      'Contact Royal Parcel at 11104 Magnolia Blvd, North Hollywood, CA 91601. Call (818) 299-3899 or email royalparcelnoho@gmail.com. Open Mon–Fri 9:30 AM – 6:00 PM, Sat 9:30 AM – 1:00 PM. Shipping, mailboxes, notary, and more.'
    );
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitError(false);

    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        'form-name': 'contact',
        ...formData,
      }).toString(),
    })
      .then((res) => {
        if (res.ok) {
          setSubmitted(true);
        } else {
          setSubmitError(true);
        }
      })
      .catch(() => setSubmitError(true));
  };

  return (
    <>
      {/* Page Hero */}
      <section className="page-hero">
        <div className="container">
          <p className="section-overline section-overline--light" style={{ justifyContent: 'center' }}>
            <span style={{ display: 'none' }}>—</span>Get In Touch
          </p>
          <h1>Contact Us</h1>
          <p>We'd love to hear from you. Visit us, call, or send a message — we're here to help.</p>
        </div>
      </section>

      {/* Contact Content */}
      <section className="contact-section">
        <div className="container">
          <div className="contact-grid">
            {/* Contact Info Cards */}
            <div className="contact-info">
              <div className="contact-info-card">
                <div className="contact-info-icon">{icons.mapPin}</div>
                <div>
                  <h4>Visit Our Store</h4>
                  <p>
                    11104 Magnolia Blvd.<br />
                    North Hollywood, CA 91601
                  </p>
                </div>
              </div>

              <div className="contact-info-card">
                <div className="contact-info-icon">{icons.phone}</div>
                <div>
                  <h4>Call Us</h4>
                  <p>
                    <a href="tel:+18182993899">Phone: (818) 299-3899</a><br />
                    Fax: (818) 505-3111
                  </p>
                </div>
              </div>

              <div className="contact-info-card">
                <div className="contact-info-icon">{icons.mail}</div>
                <div>
                  <h4>Email Us</h4>
                  <p>
                    <a href="mailto:royalparcelnoho@gmail.com">royalparcelnoho@gmail.com</a><br />
                    <a href="https://royalparcelinc.com" target="_blank" rel="noopener noreferrer">royalparcelinc.com</a>
                  </p>
                </div>
              </div>

              <div className="contact-info-card">
                <div className="contact-info-icon">{icons.clock}</div>
                <div>
                  <h4>Business Hours</h4>
                  <p>
                    Mon – Fri: 9:30 AM – 6:00 PM<br />
                    Saturday: 9:30 AM – 1:00 PM<br />
                    Sunday: Closed
                  </p>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="contact-form-wrapper">
              {!submitted ? (
                <>
                  <h3>Send Us a Message</h3>
                  <p>Fill out the form below and we'll get back to you as soon as possible.</p>

                  <form name="contact" method="POST" data-netlify="true" data-netlify-honeypot="bot-field" onSubmit={handleSubmit}>
                    <input type="hidden" name="form-name" value="contact" />
                    <p hidden><label>Don't fill this out: <input name="bot-field" /></label></p>
                    <div className="form-row">
                      <div className="form-group">
                        <label htmlFor="firstName">First Name</label>
                        <input
                          type="text"
                          id="firstName"
                          name="firstName"
                          value={formData.firstName}
                          onChange={handleChange}
                          placeholder="Your first name"
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="lastName">Last Name</label>
                        <input
                          type="text"
                          id="lastName"
                          name="lastName"
                          value={formData.lastName}
                          onChange={handleChange}
                          placeholder="Your last name"
                          required
                        />
                      </div>
                    </div>

                    <div className="form-row">
                      <div className="form-group">
                        <label htmlFor="email">Email Address</label>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          placeholder="you@email.com"
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="phone">Phone Number</label>
                        <input
                          type="tel"
                          id="phone"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          placeholder="(818) 000-0000"
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label htmlFor="service">Service Interested In</label>
                      <select
                        id="service"
                        name="service"
                        value={formData.service}
                        onChange={handleChange}
                      >
                        <option value="">Select a service...</option>
                        <option value="Shipping">Packing & Shipping</option>
                        <option value="Mailbox">Private Mailbox Rental</option>
                        <option value="Notary">Notary Public</option>
                        <option value="Print & Copy">Print, Copy & Fax</option>
                        <option value="Shredding">Secure Shredding</option>
                        <option value="International">International Shipping</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>

                    <div className="form-group">
                      <label htmlFor="message">Message</label>
                      <textarea
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        placeholder="How can we help you?"
                        rows="5"
                        required
                      ></textarea>
                    </div>

                    {submitError && (
                      <p style={{ color: '#c0392b', marginBottom: '1rem' }}>
                        Something went wrong. Please try again or email us directly at{' '}
                        <a href="mailto:royalparcelnoho@gmail.com" style={{ color: '#c0392b', fontWeight: 600 }}>
                          royalparcelnoho@gmail.com
                        </a>.
                      </p>
                    )}

                    <div className="form-submit">
                      <button type="submit" className="btn btn-primary">
                        Send Message {icons.send}
                      </button>
                    </div>
                  </form>
                </>
              ) : (
                <div className="form-success">
                  {icons.check}
                  <h3>Message Sent!</h3>
                  <p>
                    Thank you for reaching out. We'll get back to you as soon as possible.
                    You can also reach us at{' '}
                    <a href="mailto:royalparcelnoho@gmail.com" style={{ color: 'var(--gold-dark)', fontWeight: 600 }}>
                      royalparcelnoho@gmail.com
                    </a>
                    {' '}or call{' '}
                    <a href="tel:+18182993899" style={{ color: 'var(--gold-dark)', fontWeight: 600 }}>
                      (818) 299-3899
                    </a>.
                  </p>
                  <br />
                  <button
                    className="btn btn-outline"
                    onClick={() => {
                      setSubmitted(false);
                      setFormData({ firstName: '', lastName: '', email: '', phone: '', service: '', message: '' });
                    }}
                  >
                    Send Another Message
                  </button>
                </div>
              )}
            </div>
          </div>

          {/* Google Maps */}
          <div className="contact-map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3301.1!2d-118.3734!3d34.1685!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c295e3c81f9bed%3A0x!2s11104+Magnolia+Blvd%2C+North+Hollywood%2C+CA+91601!5e0!3m2!1sen!2sus!4v1700000000000"
              title="Royal Parcel Location - 11104 Magnolia Blvd, North Hollywood, CA 91601"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </section>
    </>
  );
}

export default Contact;
